<template>
  <sup v-if="!!referenceNumber" @click="scrollToFootnotes">[{{ referenceNumber }}]</sup>
</template>

<script setup lang="ts">
import { computed, defineProps, onBeforeUnmount, onMounted, toRefs, watch } from 'vue';
import { useLocalFootnotesStore } from '../../stores/localFootnotes/local-footnotes.composable';
import { FOOTNOTE_CONTAINER_ID } from './constants';

export interface LocalFootnoteReference {
  text: string;
  context?: string;
}

const props = withDefaults(defineProps<LocalFootnoteReference>(), {
  context: 'default',
});

const { text } = toRefs(props);

const {
  state: localFootnoteState,
  dispatchers: { addFootnote, removeFootnote },
} = useLocalFootnotesStore();
const referenceNumber = computed<number | null | undefined>(
  () => localFootnoteState.contexts[props.context]?.find((item) => item.text === text.value)?.referenceNumber,
);

onMounted(async () => {
  addFootnote({ text: text.value, context: props.context });
});

onBeforeUnmount(async () => {
  removeFootnote({ text: text.value, context: props.context });
});

watch(text, async (newText, oldText) => {
  if (newText !== oldText) {
    removeFootnote({ text: oldText, context: props.context });
    addFootnote({ text: newText, context: props.context });
  }
});

const scrollToFootnotes = (event: MouseEvent) => {
  event.preventDefault();
  event.stopPropagation();

  const footnoteContainer = document.getElementById(FOOTNOTE_CONTAINER_ID);

  if (footnoteContainer) {
    const offsetTop = footnoteContainer.offsetTop;

    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }
};
</script>

<style lang="scss" src="./localFootnoteReference.scss" scoped />
